import { instanceApi } from './api'

export const getBrindesPorAcao = ( fluxoBrindes, modalidadeBrindes, planoBrindes ) => instanceApi.get( `/v1/brindes/${fluxoBrindes}?modalidade=${modalidadeBrindes}&plano=${planoBrindes}` )
